<template>
    <div class="row align-items-center">
        <div class="col-12 col-md-6 offset-xl-2 offset-md-1 order-md-2 mb-5 mb-md-0">
            <!-- Image -->
            <div class="text-center">
                <img src="@/assets/img/illustrations/doctors.svg" alt="..." class="img-fluid" />
            </div>
        </div>
        <div class="col-12 col-md-5 col-xl-4 order-md-1 my-5">
            <!-- Heading -->
            <h1 class="display-4 text-center mb-3">{{$t('Logging out')}}...</h1>
            <p class="text-muted text-center mb-5">{{$t('See you soon')}}</p>
        </div>
    </div>
    <!-- / .row -->
</template>


<script>
import { mapActions, mapMutations } from 'vuex';

export default {
    methods: {
        ...mapActions('auth', ['logout']),
        ...mapActions('sessions', ['remove']),
        // ...mapMutations('customers', { clearCustomers: 'clearAll' }),
        // ...mapMutations('treatment', { clearTreatment: 'clearAll' }),
        // ...mapMutations('media', { clearMedia: 'clearAll' }),

    },
	mounted() {
        // this.$store.dispatch('auth/logout').then(data => {
        const promises = [];

        if(localStorage.getItem('feathers-jwt'))
          promises.unshift(this.remove(localStorage.getItem('feathers-jwt')));
        
        promises.push(this.logout());

        Promise.all(promises).catch(error => {
            this.errors = error.message;
        }).finally(() => {
            if (this.$route.query.emergency) {
                window.location.href = "about:blank";
            } else {
                setTimeout(() => {
                    location.reload();
                }, 600);
                this.$router.push({name: 'login'});
            }
        });
    }
}

</script>


